/*
 Details

 Szczegóły


 historia:
  04-2019 JW - start
  19-05-2019 - rezygnacja z komponentu podrzędnego
  30-05-2019 = Usunąć selRoom i korzystać z details

*/

import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { MuiThemeProvider, Theme, withStyles } from "@material-ui/core/styles";
import { connect, Provider } from 'react-redux';
import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import { Typography, Grid } from '@material-ui/core';
import CardMedia from '@material-ui/core/CardMedia';

import { AppState, IPageState, store, Actions, PanelState, minDaysLater, } from '../appredux'

//import './Details.css'
import { WithStyles } from '@material-ui/styles';
import CONFIG from '../cfg/config';
import {Room} from './Room';
import Gallery from './common/gallery'
import roomImg from 'app/assets/noImage.jpg';

import { toIloswWAndData, getDate } from 'app/common/ReservationHelpers';
import { selectTheme } from './common/helpers';
import ReactDOM from 'react-dom';
import DialogNoReservation from './common/DialogNoReservation';

//PM 2021-07-07
type DetailsPar = {
  //roomCategory : string,
  page: IPageState,
  open: boolean,
  details: { opis: string; info: string; cena: string; cenaZa: string; dniMin: string; osobMax: string, podstrona?: number },//webRoomDetails,
  close: () => void,
  pokoje_dostepne: boolean,
  room: Room,
  windowWidth: number,  
}
interface Values {
  price: string
}
type DetailState = {
  visible: boolean,
  //values: Values,
}

class Details extends React.Component<DetailsPar & WithTranslation & WithStyles<typeof styles>, DetailState>  {
  //price: string = 'price';
  //value: string = '';

  constructor(props: DetailsPar & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    this.state = {
      visible: false,
      //values: { price: 'price' },
    }
  }

  handleClose = () => {
    this.props.close()
  };

  openGalery = () => {
    this.setState({ visible: true })
  }

  closeGalery = () => {
    this.setState({ visible: false })
  }


  ImgError = (source: any) => {
    source.target.src = roomImg;
    source.onerror = "";
    return true;
  }
  // -
  //handleChange = (event: any, value: string) => {
  //  this.setState({ ...this.state, values: { price: value } })
  //};

  // personsIcons = () => {
  //   const { classes } = this.props;
  //   let icons = [];
  //   for (let i = 0; i < Number(this.props.details.iloscMiejsc); i++) {
  //     icons.push(<PersonIcon style={{
  //       fontSize: "12px",
  //       fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
  //       lineHeight: "20px",
  //       fontWeight: 400, marginTop: "4px"
  //     }} />)
  //   }
  //   return (
  //     <span className={classes.primary} style={{ float: 'left', marginLeft: "4.3px" }}>
  //       {this.props.details.iloscMiejsc}
  //       {/* {icons} */}
  //     </span>
  //   )
  // }

  //   async getDetails() {
  //           roomsService.getDetails(
  //             {
  //               hotelId: CONFIG.hotelID,
  //               lang: this.props.page.lang,
  //               roomCategory: this.props.details.roomCategory,
  //               dateFrom: this.props.page.dateFrom,
  //               dateTo: this.props.page.dateTo
  //             }, {}
  //           )
  //             .then(
  //               (res : webRoomDetails) => {
  //                 console.log(res)
  // //                alert(JSON.stringify(res))
  //                 this.setState({...this.state,
  //                   details : res,
  //                   lang: this.props.page.lang,
  //                   selected : true})
  //               }
  //             )
  //             .catch( (err : any) => {
  // //
  // //alert('Błąd odczytu'+JSON.stringify(err) );
  //                 console.error
  //                }
  //             );
  //          }

  // componentDidMount() {
  //     this.getDetails();
  // }

  // toBasket() {
  //   if (this.state.values.price=='price1')
  //     AddItem(this.props.details.roomCategory, this.props.details.price1)
  //   else if (this.state.values.price=='price2')
  //     AddItem(this.props.details.roomCategory, this.props.details.price2)
  //   else if (this.state.values.price=='price3')
  //     AddItem(this.props.details.roomCategory, this.props.details.price3)
  //   else if (this.state.values.price=='price4')
  //     AddItem(this.props.details.roomCategory, this.props.details.price4)
  //   else
  //     AddItem(this.props.details.roomCategory, 0)
  // }

  // //Co wyswietlic po naglowki "Dostepne pokoje", tak albo nie
  // TakNie = () => {
  //   if (this.props.details.vacantRooms === 1)
  //     return (
  //       <Typography
  //         style={{
  //           float: "left", fontWeight: "bold", display: "contents",
  //           fontSize: "12px", fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
  //           lineHeight: "20px"
  //         }}
  //         color='primary'>
  //         <Trans>Yes</Trans>
  //       </Typography>
  //     )
  //   else
  //     return (
  //       <Typography style={{
  //         float: "left", fontWeight: "bold", display: "contents",
  //         color: "red", fontSize: "12px", fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
  //         lineHeight: "20px",
  //       }}>
  //         <Trans>No</Trans>
  //       </Typography>
  //     )
  // }

 

  reserve = async () => {
    if(CONFIG.hotelRezerwuj !== "1"){

      ReactDOM.render(
        <Provider store={store}>
            <MuiThemeProvider theme={selectTheme("5")}>
                <DialogNoReservation randomNum={Math.random()}/>
            </MuiThemeProvider>
        </Provider>, document.getElementById("dialog"))

    } else {
    const minDays = Number(this.props.room.minIloscDni)
    let date: string | undefined;

    if(this.props.details.podstrona){
      await store.dispatch(Actions.pageState.setPodstrona(this.props.details.podstrona || 0)); 
      this.handleClose()
    } else {

    if (CONFIG.grafikiRodzaj === "0" || CONFIG.grafikiRodzaj === "3") {

      let row1 = this.props.page.grafik.filter(x => Number(this.props.room.id) === x.www_rodz_pokoi_id).map(x => toIloswWAndData(x.dostepna_ilosc_pokoi, x.data))
      const dateRow1Index = row1.findIndex(x => x.iloscW >= 1)
      date = (dateRow1Index !== -1) ? getDate(row1[dateRow1Index], row1, dateRow1Index, minDays) : undefined;
    } else if (CONFIG.grafikiRodzaj === "1") {
      let row2 = this.props.page.grafikRodzaje.filter(x => this.props.room.rodzPokoi.trim() === x.rodzPokoi.trim() && x.typ === 3).map(x => toIloswWAndData(x.iloscW, x.data))
      const dateRow2Index = row2.findIndex(x => x.iloscW >= 1)
      date = (dateRow2Index !== -1) ? getDate(row2[dateRow2Index], row2, dateRow2Index, minDays) : undefined;
    } else if (CONFIG.grafikiRodzaj === "2") {
      let row3 = this.props.page.grafikNumery.filter(x => this.props.room.pokoj === x.pokoj && x.typ === 3).map(x => toIloswWAndData(x.iloscW, x.data))
      const dateRow3Index = row3.findIndex(x => x.iloscW >= 1)
      date = (dateRow3Index !== -1) ? getDate(row3[dateRow3Index], row3, dateRow3Index, minDays) : undefined;
    }


    //let filteredDates = this.props.page.grafik.filter(x => Number(this.props.room.id) == x.www_rodz_pokoi_id)

    //vscTest
    //console.log(this.props.page.grafik)
    //.log(filteredDates)
    //console.log(date)

    if (date) {
      if (date !== this.props.page.dateFrom) {
        await store.dispatch(Actions.pageState.setDateFromFormularz(date));
        await store.dispatch(Actions.pageState.setDateTo(minDaysLater(date, minDays)));
      } else {
        await store.dispatch(Actions.pageState.setDateFromFormularz(this.props.page.dateFrom));
        await store.dispatch(Actions.pageState.setDateTo(minDaysLater(this.props.page.dateFrom, minDays)));
      }

      await store.dispatch(Actions.pageState.setRoomNumber(this.props.room.pokoj));
      //await store.dispatch(Actions.pageState.restart());

      if (CONFIG.grafikiRodzaj === "0" || CONFIG.grafikiRodzaj === "3") {
        let room = this.props.page.roomsOld.find((x => x.www_rodz_pokoi_id === this.props.room.id))
        if (room) {
          await store.dispatch(Actions.pageState.updateBasketOld(room));
        }
      }
      else {
        let room = this.props.page.rooms.find((x => x.id === this.props.room.id))
        if (room) {
          await store.dispatch(Actions.pageState.updateBasket(room));
        }
      }

      await store.dispatch(Actions.pageState.clearDaneNIP()); // mz 2022-06-24
      await store.dispatch(Actions.pageState.setPanelState(PanelState.psUser));
    } //else {
     // this.setState({ openError: true })
    //}

  }
  }
}

  //PM 2021-07-27
  render = () => {
    const { classes, t } = this.props;

    const fotoUrl = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/${this.props.room.galleryRodzPokoi}/th_foto.jpg`
    const lPhotos = t('Photos')

    // , display: this.state.visible? "none" : "flex"
    return (
      <>
      <Dialog PaperProps={{ style: { maxHeight: "100%" } }}
        fullWidth
        //fullScreen={false}
        open={this.props.open && !this.state.visible}
        aria-labelledby="responsive-dialog-title"
        classes={{paper: classes.window}}
      >
        {/* <Paper className={"Paper"} elevation={2} classes={{root: classes.paper}}></Paper>   */}
        <DialogTitle disableTypography style={{padding: "16px 24px 0px"}}>
          <Typography component="h6" color="primary" className={`${classes.headline}`}>
            <b> {this.props.details.opis} </b>
          </Typography>
          <hr />
        </DialogTitle>
        <DialogContent>
          {/* <div style={{ justifyContent: "center", display: "flex" }}> */}
          {/* <DialogContentText className={`${classes.text} ${classes.body}`} style={{ width: window.innerWidth > 600 ? "30%" : "35%", minWidth: "110px" }}>
              <Trans>Price</Trans>{': '}
              <b className={classes.primary}>
                {this.props.details.cena_pokoj}
                <span> zł</span>
              </b>
            </DialogContentText>
            <DialogContentText className={`${classes.text} ${classes.body}`} style={{ width: "25%" }}>
              <div style={{ float: 'left' }}><Trans>Persons</Trans>:</div> <b className={classes.primary} >{this.personsIcons()}</b>
            </DialogContentText> */}
          {/* <DialogContentText className={`${classes.text} ${classes.body}`} style={{ width: "30%" }}>
                  <Trans>Available</Trans>{': '}{this.TakNie()}
                </DialogContentText> */}
         
         <Grid container style={{ padding: "0px 16px" }}>
            <Grid
              item
              style={{ width: window.innerWidth > 599 ? "197px" : '100%' }}   
            >
              <Typography className={classes.description} color="primary">
                  <Trans>Price</Trans>{" "}<span className={classes.value}  ><b>{this.props.details.cena} zł</b></span>
                </Typography>
                <Typography className={classes.description} color="primary">
                  <Trans>Price</Trans>{" "}<Trans>For</Trans>{" "}<span className={classes.value}  ><b>{this.props.details.cenaZa}</b></span>
                </Typography>
                <br />
                <Typography className={classes.description} color="primary">
                  <Trans>{'Min days'}</Trans>
                  <span className={classes.value}  >
                    <b>{" " + this.props.details.dniMin}</b>
                  </span>
                </Typography>
                <Typography className={classes.description} color="primary">
                  <Trans>{'Min people'}</Trans>
                  <span className={classes.value}  ><b>{" 1"}</b></span>
                </Typography>
                <Typography className={classes.description} color="primary">
                  <Trans>{'Max people'}</Trans>
                  <span className={classes.value}  ><b>{" " + this.props.details.osobMax}</b></span>
                </Typography>
                <br />
              <div className={classes.media}>
                <CardMedia
                  style={{ objectFit: "fill" }}
                  image={fotoUrl}
                  title={this.props.room.opis}
                  onClick={() => { this.openGalery() }}
                  onError={this.ImgError}
                  component="img"
                />
              </div>
              <Typography className={`${classes.description}`} style={{textAlign: "center", cursor: "pointer", paddingRight: window.innerWidth > 599 ? "20%" : "0%", marginTop: "8px"}} color="primary" onClick={() => { this.openGalery() }}>
                <Trans>Gallery</Trans>
              </Typography>
            </Grid>
            <Grid
              item
              style={{ width: window.innerWidth > 599 ? "calc(100% + -197px)" : '100%', marginTop: window.innerWidth > 599 ? '0' : '20px' }}         
            >   
              <div className={classes.body} style={{ textAlign: "justify", width: "100%", paddingRight: "16px" }} 
                dangerouslySetInnerHTML={{ __html: this.props.details.info }}>
              </div>
            </Grid>
         </Grid>

        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" size="small"
            onClick={this.handleClose}>
            <b style={{ textTransform: "lowercase" }}><Trans>Back</Trans></b>
          </Button>
          <Button variant={this.props.pokoje_dostepne ? "contained" : "outlined"} color="primary" size="small" //className={this.props.pokoje_dostepne ? `${classes.button}` : `${classes.buttonWhite}`} 
            onClick={async () => { await this.reserve() }}
          
          >
            <b style={{ textTransform: "lowercase" }}><Trans>{this.props.details.podstrona? "See" : "Reserve"}</Trans></b>
          </Button>
        </DialogActions>
        {/* </Paper>     */}
      </Dialog>
      <Gallery className={classes.actions} button={true} title={lPhotos} visible={this.state.visible} close={this.closeGalery}
          icon="icon-picture" room={this.props.room.galleryRodzPokoi} />
      </>
    )
  }
}

const styles = (theme: Theme) => ({
  window: {
    maxWidth: "520px"
  },
  textField: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  body: {
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight
  },
  primary: {
    color: theme.palette.primary.main
  },
  back: {
    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
    background: "linear-gradient(to bottom, #e49a4d, #c9823c)",
    border: "1px solid #c9823c",
    padding: "6px 8px 5px",
    lineHeight: "13px",
    fontSize: "11px",
    marginTop: "24px"
  },
  paper: {
    overflow: "visible"
  },
  // headline: {
  //   fontFamily: "\"'Open Sans'\", sans-serif",
  //   lineHeight: "20px",
  //   fontSize: "14px",
  //   fontWeight: 600
  // },
  headline: {
    fontSize: "12px",
  },
  text: {
    color: theme.palette.text.primary
  },
  description: {
    paddingRight: "5px",
    fontSize: "12px",
    fontWeight: 400,
    //color: "#555",
    lineHeight: "20px"
  },
  value: {
    fontSize: "12px",
    lineHeight: "20px",
    fontWeight: "bold" as "bold"
  },
  actions: {
    display: 'flex',
    height: "42px"
  },
  media: {
    cursor: "pointer",
    border: "5px solid #fff",
    boxShadow: "2px 2px 3px 2px #e6e6e6",
    width: "77%",
    "@media screen and (max-width: 600px)": {
      width: "calc(100% + -10px)",
    },
  },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default
  connect(mapStateToProps)(withTranslation()(withStyles(styles)(Details)));

/*
Podpowiedź na dole:

    <Snackbar  open={true}
    message="Wybierz wariant i kliknij [Rezerwuj]"
    />
*/
/* do rozważena - inny checkbox
<FormGroup>
      {initialItems.map(({ name, Icon, CheckedIcon }, index) => (
        <FormControlLabel
          key={index}
          control={
            <Checkbox
              checked={this.state.items[name]}
              onChange={this.onChange1}
              inputProps={{ name }}
              icon={<Icon fontSize="small" />}
              checkedIcon={<CheckedIcon fontSize="small" />}
            />
          }
          label={name}
        />
      ))}
    </FormGroup>
*/

/*
*/